import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { createSpeedLimitCertificateService } from "../service/createSpeedLimitCertificate.service";

const initialState = {
  id: null,
  document: null,
  date: "",
};

export const useSpeedLimitCertificateCommand = (refresh) => {
  const fetchData = useFetch();
  const [speedLimitCertificate, setSpeedLimitCertificate] =
    useState(initialState);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });

  const handleChange = ({ name, value }) => {
    setSpeedLimitCertificate((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      hasErrors: false,
      errors: {
        ...prev.errors,
        [name]: null,
      },
    }));
  };

  const createSpeedLimitCertificate = async () => {
    setLoading(true);
    try {
      if (!validations(speedLimitCertificate)) {
        return;
      }

      const formData = new FormData();
      formData.append("date", speedLimitCertificate.date);
      formData.append("file", speedLimitCertificate.document);

      const response = await createSpeedLimitCertificateService(fetchData)(
        formData
      );

      Swal.fire({
        title: "Éxito",
        text: "El certificado de límite de velocidad se creó correctamente.",
        icon: "success",
      });
      setSpeedLimitCertificate(initialState);
      refresh?.();
      return response;
    } catch (error) {
      console.error("Error creating speed limit certificate:", error);
      setErrors({
        hasErrors: true,
        errors: error.response?.data || {
          general: "An error occurred while creating the certificate.",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const validations = (data) => {
    const newErrors = {};
    if (!data.date) {
      newErrors.date = "La fecha es requerida.";
    }
    if (!data.document) {
      newErrors.document = "El documento es requerido.";
    }
    if (data.document && data.document.type !== "application/pdf") {
      newErrors.document = "El archivo debe ser un PDF.";
    }
    const hasErrors = Object.keys(newErrors).length > 0;
    setErrors({
      hasErrors,
      errors: newErrors,
    });
    return !hasErrors;
  };

  return {
    speedLimitCertificate,
    loading,
    errors,
    handleChange,
    createSpeedLimitCertificate,
  };
};
